export const filterUnique = <T>(arr: Array<T>) => {
  return Array.from(new Set(arr));
};
